import moment, { unitOfTime } from 'moment';

export function getMillisecondDiffFromNow(timestamp: string): number {
    return getDiffFromNow(timestamp, 'millisecond');
}

export function getDiffFromNow(timestamp: string, timeUnit?: unitOfTime.Diff): number {
    return moment(timestamp).diff(moment(), timeUnit);
}



// WEBPACK FOOTER //
// ./src/services/time-query.ts